import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface FiltersState {
    [indicatorId: string]: {
        fromYear: number;
        toYear: number;
    };
}

const currentYear = new Date().getFullYear();

const initialState: FiltersState = {};

// Initialize state with filters from localStorage
Object.keys(localStorage).forEach((key) => {
    if (key.startsWith('filter_')) {
        const storedFilter = JSON.parse(localStorage.getItem(key) || '{}');
        if (storedFilter && storedFilter.indicatorId) {
            initialState[storedFilter.indicatorId] = {
                fromYear: storedFilter.fromYear || 2018,
                toYear: storedFilter.toYear || currentYear,
            };
        }
    }
});

const filterSlice = createSlice({
    name: 'filters',
    initialState,
    reducers: {
        setFilters: (state, action: PayloadAction<{ indicatorId: string; fromYear: number; toYear: number }>) => {
            const { indicatorId, fromYear, toYear } = action.payload;
            state[indicatorId] = { fromYear, toYear };
            localStorage.setItem(`filter_${indicatorId}`, JSON.stringify({ indicatorId, fromYear, toYear }));
        },
        resetFilters: (state, action: PayloadAction<string>) => {
            delete state[action.payload];
            localStorage.removeItem(`filter_${action.payload}`);
        },
    },
});

export const { setFilters, resetFilters } = filterSlice.actions;
export default filterSlice.reducer;
